import { BaseJsStepAction } from './baseJsStepAction';

export class JsConditionStepAction extends BaseJsStepAction {
    protected isFailedResult(resultValue: any) {
        return !resultValue;
    }
}
